var map = {
	"./avatar": 60,
	"./avatar.svg": 60,
	"./cs": 61,
	"./cs.svg": 61,
	"./de": 62,
	"./de.svg": 62,
	"./en": 63,
	"./en.svg": 63,
	"./search": 64,
	"./search.svg": 64,
	"./warning": 65,
	"./warning.svg": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 101;